import React from 'react'
import { useSelector } from 'react-redux'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { Paper } from '@material-ui/core'


export default function NthQLDPHNDetail() 
{
  const nthqldphnDetails = useSelector(state => state.admin.NthQLDPHNDetails)

  const columns = [
    { field: 'id', headerName: 'BookingID', width: 100,  hide: true },
    { field: 'clientName', headerName: 'Name', width: 200 },
    { field: 'providerName', headerName: 'Provider', width: 200 },
    { field: 'bookingDate', headerName: 'Booking Date', width: 160 },
    { field: 'status', headerName: 'Status', width: 110 }
  ];


  return (
    <>
      { nthqldphnDetails ? 
        <Paper style={{ height: 700 }}>
          <DataGridPro  
            disableColumnMenu={true}
            rows={nthqldphnDetails} columns={columns} pageSize={10} checkboxSelection={false} sortModel={[{ field: 'clientName', sort: 'asc' }]}
           />
        </Paper>
      : ('None')
      }
    </>
  )
}
